import { AgGrid } from "@jsq/ds/core";
import { formatShortFormDate } from "#utils/datetime";
import * as styles from "./styles_vanilla.css";
import type { TicketRowItem } from "./types";

export function getClientCellClass(params: AgGrid.CellClassParams<TicketRowItem>): string {
  const customers = params.data?.customers;
  if (!customers || customers.length === 0) {
    return styles.clientCellStyles.danger;
  }
  return styles.clientCellStyles.default;
}

export function getTicketRowId(params: AgGrid.GetRowIdParams<TicketRowItem>): string {
  return params.data.id;
}

export function getClientCellStyle(customers: string[] | null | undefined): string {
  if (!customers || customers.length === 0) {
    return styles.clientCellStyles.danger;
  }
  return styles.clientCellStyles.default;
}

export function formatDateValue(params: AgGrid.ValueFormatterParams<TicketRowItem>): string {
  if (!params.value) return "";
  return formatShortFormDate(String(params.value));
}
